import React from 'react';
import {
  FilterCompanyGroup,
  FilterCustom,
  FilterDerivative,
  FilterIndustry,
  FilterPutThrough,
} from './common/filters';
import FilterCoveredWarrant from './common/filters/FilterCoveredWarrant';

export default function Filter() {
  return (
    <>
      <FilterCustom />
      <FilterCompanyGroup />
      <FilterIndustry />
      <FilterDerivative />
      <FilterPutThrough />
      <FilterCoveredWarrant />
    </>
  );
}
